
const Webinars = () => (
  <div className="pt-24 px-6 max-w-7xl mx-auto">
    <h1 className="text-4xl font-bold mb-8">Webinars</h1>
    <p>Join our webinars to learn about employee recognition best practices.</p>
  </div>
);

export { Page }

function Page() {
  return <Webinars />;
}
